export const types = {
    ECHEQ_RULE_PRE_REQUEST: "echeqRule/ECHEQ_RULE_PRE_REQUEST",
    ECHEQ_RULE_PRE_SUCCESS: "echeqRule/ECHEQ_RULE_PRE_SUCCESS",
    ECHEQ_RULE_PRE_FAILURE: "echeqRule/ECHEQ_RULE_PRE_FAILURE",
    ECHEQ_RULE_PREVIEW: "echeqRule/ECHEQ_RULE_PREVIEW",
    ECHEQ_RULE_PREVIEW_SUCCESS: "echeqRule/ECHEQ_RULE_PREVIEW_SUCCESS",
    ECHEQ_RULE_PREVIEW_FAILURE: "echeqRule/ECHEQ_RULE_PREVIEW_FAILURE",
    ECHEQ_RULE_SEND: "echeqRule/ECHEQ_RULE_SEND",
    ECHEQ_RULE_SEND_SUCCESS: "echeqRule/ECHEQ_RULE_SEND_SUCCESS",
    ECHEQ_RULE_SEND_FAILURE: "echeqRule/ECHEQ_RULE_SEND_FAILURE",
    ECHEQ_RULE_SET_DATA: "echeqRule/ECHEQ_RULE_SET_DATA",
    ECHEQ_RULE_SET_INITIAL_VALUES: "echeqRule/ECHEQ_RULE_SET_INITIAL_VALUES",
    ECHEQ_CLEAN_FORM: "echeqRule/ECHEQ_CLEAN_FORM",
    GO_BACK_ECHEQS_RULE: "echeqRule/GO_BACK_ECHEQS_RULE",
    DOWNLOAD_ECHEQ_RULE_ERRORS_REQUEST: "echeqRule/DOWNLOAD_ECHEQ_RULE_ERRORS_REQUEST",
    DOWNLOAD_ECHEQ_RULE_ERRORS_FAILURE: "echeqRule/DOWNLOAD_ECHEQ_RULE_ERRORS_FAILURE",
    DOWNLOAD_ECHEQ_RULE_ERRORS_SUCCESS: "echeqRule/DOWNLOAD_ECHEQ_RULE_ERRORS_SUCCESS",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingDownload: false,
    accountList: [],
    daysBeforeList: [],
    actionsList: [],
    conditionsList: [],
    subConditionsIssuerList: [],
    subConditionsAmountList: [],
    subConditionsReceivedList: [],
    initialValues: {
        account: "",
        action: "",
        conditions: [],
        name: "",
    },
    echeqRuleTransactionData: {},
    goBackEcheqsRule: false,
    actionType: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        accounts,
        daysBefore,
        actions,
        conditions,
        subConditionsIssuer,
        subConditionsAmount,
        subConditionsReceived,
        initialValues,
        echeqRuleTransactionData,
        goBackEcheqsRule,
        actionType,
    } = action;

    switch (action.type) {
        case types.ECHEQ_RULE_PRE_REQUEST:
        case types.ECHEQ_RULE_PREVIEW:
        case types.ECHEQ_RULE_SEND:
            return {
                ...state,
                fetching: true,
            };
        case types.ECHEQ_RULE_PRE_FAILURE:
        case types.ECHEQ_RULE_SEND_FAILURE:
        case types.ECHEQ_RULE_SEND_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.ECHEQ_RULE_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                accountList: accounts,
                daysBeforeList: daysBefore,
                actionsList: actions,
                conditionsList: conditions,
                subConditionsIssuerList: subConditionsIssuer,
                subConditionsAmountList: subConditionsAmount,
                subConditionsReceivedList: subConditionsReceived,
            };
        case types.ECHEQ_RULE_PREVIEW_SUCCESS:
        case types.ECHEQ_RULE_PREVIEW_FAILURE:
            return {
                ...state,
                fetching: false,
                initialValues,
            };

        case types.ECHEQ_RULE_SET_DATA:
            return {
                ...state,
                echeqRuleTransactionData,
            };

        case types.ECHEQ_CLEAN_FORM:
            return {
                ...state,
                initialValues: INITIAL_STATE.initialValues,
                fetching: false,
            };
        case types.GO_BACK_ECHEQS_RULE:
            return {
                ...state,
                goBackEcheqsRule,
            };
        case types.ECHEQ_RULE_SET_INITIAL_VALUES:
            return {
                ...state,
                actionType,
                initialValues: !initialValues ? INITIAL_STATE.initialValues : initialValues,
            };
        case types.DOWNLOAD_ECHEQ_RULE_ERRORS_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_ECHEQ_RULE_ERRORS_FAILURE:
        case types.DOWNLOAD_ECHEQ_RULE_ERRORS_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        default:
            return state;
    }
};

export const actions = {
    echeqRulePreRequest: () => ({
        type: types.ECHEQ_RULE_PRE_REQUEST,
    }),
    echeqRulePreviewRequest: (valuesForm) => ({
        type: types.ECHEQ_RULE_PREVIEW,
        valuesForm,
    }),
    echeqRuleSend: (valuesForm) => ({
        type: types.ECHEQ_RULE_SEND,
        valuesForm,
    }),
    echeqRuleTransactionSetData: (echeqRuleTransactionData) => ({
        type: types.ECHEQ_RULE_SET_DATA,
        echeqRuleTransactionData,
    }),
    echeqRuleCleanData: () => ({
        type: types.ECHEQ_CLEAN_FORM,
    }),
    setGoBackEcheqsRule: (goBackEcheqsRule) => ({
        type: types.GO_BACK_ECHEQS_RULE,
        goBackEcheqsRule,
    }),
    echeqRuleDownloadErrors: (format, numberRule) => ({
        type: types.DOWNLOAD_ECHEQ_RULE_ERRORS_REQUEST,
        format,
        numberRule,
    }),
};

export const selectors = {
    getFetching: ({ echeqRule }) => echeqRule.fetching,
    getAccountList: ({ echeqRule }) => echeqRule.accountList,
    getDaysBeforeList: ({ echeqRule }) => echeqRule.daysBeforeList,
    getActionsList: ({ echeqRule }) => echeqRule.actionsList,
    getConditionsList: ({ echeqRule }) => echeqRule.conditionsList,
    getSubConditionsIssuerList: ({ echeqRule }) => echeqRule.subConditionsIssuerList,
    getSubConditionsAmountList: ({ echeqRule }) => echeqRule.subConditionsAmountList,
    getSubConditionsReceivedList: ({ echeqRule }) => echeqRule.subConditionsReceivedList,
    getInitialValues: ({ echeqRule }) => echeqRule.initialValues,
    getEcheqRuleTransactionData: ({ echeqRule }) => echeqRule.echeqRuleTransactionData,
    isGoBackEcheqsRule: ({ echeqRule }) => echeqRule.goBackEcheqsRule,
    getActionType: ({ echeqRule }) => echeqRule.actionType,
};
